/* In-cart subscription upsell — switches a one-time line to the Monthly plan
   via /cart/change.js (selling_plan).

   Re-render uses Dawn's canonical path (same as product-form.js add-to-cart and
   cart.js updateQuantity): request the cart sections in the SAME change call
   (sections param → HTML returned in the response, atomic), then publish
   cartUpdate and let <cart-drawer>.renderContents() repaint #CartDrawer.
   A separate fetch + manual replaceWith races with Loop/Dawn and blanks the
   drawer — so we deliberately avoid it.

   Event-delegated so it survives the drawer's re-renders. */
(function () {
  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cart-abo-upsell__btn') : null;
    if (!btn) return;

    var box = btn.closest('.cart-abo-upsell');
    if (!box || box.classList.contains('is-loading')) return;

    var key = box.getAttribute('data-line-key');
    var planId = parseInt(box.getAttribute('data-plan-id'), 10);
    var qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
    if (!key || !planId) return;

    var cart = document.querySelector('cart-drawer');
    var sectionIds = (cart && typeof cart.getSectionsToRender === 'function')
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    box.classList.add('is-loading');
    btn.disabled = true;

    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        selling_plan: planId,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.message || state.description || 'cart change error');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-abo-upsell', cartData: state });
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(state);
        }

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'subscription_upsell_accepted', selling_plan_id: planId });
        } catch (err) { /* noop */ }
        try {
          if (typeof window.zfTrack === 'function') {
            window.zfTrack('zf_abo_upsell_accepted', { selling_plan_id: planId });
          }
        } catch (err) { /* noop */ }
      })
      .catch(function (err) {
        box.classList.remove('is-loading');
        btn.disabled = false;
        if (window.console) console.warn('Abo upsell switch failed:', err);
      });
  });
})();
